import { Component, Input } from '@angular/core';

// Kept intentionally dark end-to-end (no light stops) so white initials
// text stays at/above 4.5:1 contrast everywhere in the gradient, in both
// themes — avatars don't participate in the light/dark token swap.
const GRADIENTS = [
  'linear-gradient(135deg,#c9590a,#a3241d)',
  'linear-gradient(135deg,#6b28b8,#4a1a8a)',
  'linear-gradient(135deg,#2c3aa8,#1f2a80)',
  'linear-gradient(135deg,#0d7c96,#0a5c70)',
  'linear-gradient(135deg,#0f7a48,#0a5c35)',
];

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() name = '';
  @Input() imageUrl: string;
  @Input() size = 32;
  @Input() background: string;

  get initials(): string {
    const parts = this.name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) { return '?'; }
    const first = parts[0].charAt(0);
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  }

  get gradient(): string {
    if (this.background) { return this.background; }
    let hash = 0;
    for (let i = 0; i < this.name.length; i++) { hash = this.name.charCodeAt(i) + ((hash << 5) - hash); }
    return GRADIENTS[Math.abs(hash) % GRADIENTS.length];
  }
}
